import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container } from "reactstrap";
import R from "../../../assets/RealEnglishImages/Letters/R.png";
import E from "../../../assets/RealEnglishImages/Letters/E.png";
import A from "../../../assets/RealEnglishImages/Letters/A.png";
import L from "../../../assets/RealEnglishImages/Letters/L.png";
import RealLamb from "../../../assets/RealEnglishImages/RealEnglishLamb3.png";
import "./RealEnglishSliderImages.css";
import SliderSwiper from "./SliderSwiper";
import VerticalSwiper from "./VerticalSwiper";

const RealEnglishSliderImages = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getMaxHeight = () => {
    if (screenWidth < 532) return "50px";
    if (screenWidth <= 746) return "90px";
    return "140px";
  };
  const getMaxHeightLamb = () => {
    if (screenWidth < 532) return "30px";
    if (screenWidth <= 746) return "60px";
    return "100px";
  };

  function importAll(r) {
    return r.keys().map(r); // Returns an array of imported images
  }

  const images = importAll(
    require.context(
      "../../../assets/RealEnglishImages/Facilities/ThumbnailFacilities",
      false,
      /\.(png|jpeg|jpg)$/
    )
  );

  return (
    <Container fluid>
      <Col lg={12}>
        <Card>
          <CardHeader className="py-0 pe-0">
            <div className="d-flex justify-content-center flex-wrap py-0 pe-0">
              {[R, E, A, L, RealLamb].map((imgSrc, index) => (
                <div key={index} className="navbar-brand">
                  <img
                    src={imgSrc}
                    className="card-logo img-fluid"
                    alt={`Letter-${index}`}
                    style={{
                      maxHeight: index === 4 ? getMaxHeightLamb() : getMaxHeight(),
                      width: "auto",
                    }}
                  />
                </div>
              ))}
            </div>
          </CardHeader>
          <CardBody className="px-4">
            {/* Conditionally render Swiper based on screen width */}
            {screenWidth > 747 ? (
                <SliderSwiper images={images}/>
  
            ) : (
              <VerticalSwiper images={images}/>
            )
          }
          </CardBody>
        </Card>
      </Col>
    </Container>
  );
};

export default RealEnglishSliderImages;
